module.exports = __webpack_public_path__ + "static/media/nav_menu_students.fe5d0d00.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./img/svg/nav_menu_students.svg
 ** module id = 296
 ** module chunks = 0
 **/